import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    guest: {
      guestreponse: false,
      guestid: null,
      guesttime: null,
    },
    videolink: {
      key: null,
    },
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.user = null;
    },
    guestlogin: (state, action) => {
      state.guest = action.payload;
    },
    videolinkupdate: (state, action) => {
      state.videolink = action.payload;
    },
  },
});
export const { login, logout, guestlogin, videolinkupdate } = userSlice.actions;
export const selectUser = (state) => state.user.user;
export const selectGuest = (state) => state.user.guest;
export const selectLink = (state) => state.user.videolink;

export default userSlice.reducer;
